export default __webpack_public_path__ + "static/media/women_ico.57796eaa.svg";